module.exports = __webpack_public_path__ + "img/livro_off.854a50a5.png";